import CssBaseline from '@mui/material/CssBaseline';
import FullscreenLoader from 'components/Loading/Fullscreen';
import { initHighcharts } from 'helpers/highcharts';
import { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PDF_MICROSITE } from 'routes';
import './fonts/Playfair/playfair.css';
import './fonts/typeface-roboto/index.css';
import './style.css';

const MainApp = lazy(() => import('apps/Main'));
const PdfMicrosite = lazy(() => import('apps/Pdf/App'));

initHighcharts();

const app = (
  <Suspense fallback={<FullscreenLoader />}>
    <CssBaseline />
    <BrowserRouter>
      <Routes>
        <Route path={`${PDF_MICROSITE}/*`} element={<PdfMicrosite />} />
        <Route path="/*" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  </Suspense>
);

createRoot(document.getElementById('root')!).render(app);
